import {
    isToolName,
    type AiAgentToolName,
    type ToolName,
} from '@lightdash/common';
import {
    IconChartDots3,
    IconChartHistogram,
    IconChartLine,
    IconDatabase,
    IconLayoutDashboard,
    IconPencil,
    IconPlugConnected,
    IconSchool,
    IconSearch,
    IconSelector,
    IconTable,
    IconTerminal2,
    type TablerIconsProps,
} from '@tabler/icons-react';
import type { JSX } from 'react';

export const getToolIcon = (toolName: AiAgentToolName) => {
    const iconMap: Record<ToolName, (props: TablerIconsProps) => JSX.Element> =
        {
            findExplores: IconDatabase,
            findFields: IconSearch,
            discoverFields: IconSearch,
            searchFieldValues: IconSelector,
            generateBarVizConfig: IconChartHistogram,
            generateTimeSeriesVizConfig: IconChartLine,
            generateTableVizConfig: IconTable,
            generateDashboard: IconLayoutDashboard,
            findContent: IconSearch,
            findDashboards: IconLayoutDashboard,
            findCharts: IconChartDots3,
            getDashboardCharts: IconLayoutDashboard,
            improveContext: IconSchool,
            proposeChange: IconPencil,
            runQuery: IconTable,
            runSavedChart: IconChartHistogram,
            runSql: IconTerminal2,
            listWarehouseTables: IconDatabase,
            describeWarehouseTable: IconDatabase,
        };

    return isToolName(toolName) ? iconMap[toolName] : IconPlugConnected;
};
